import moment from 'moment';
import {
    getDateRangeFromSalesSettings,
    getDefaultSalesListSettings,
    resolvePlantFilter,
    SALES_DATE_MODES,
    sanitizeSalesListSettings,
} from './salesListSettings';

const STORAGE_PREFIX = 'purchaseNoteListSettings';

export function getPurchaseSettingsStorageKey(userId) {
    return `${STORAGE_PREFIX}_${userId || 'default'}`;
}

export function getDefaultPurchaseListSettings() {
    return getDefaultSalesListSettings();
}

export function loadPurchaseListSettings(userId) {
    try {
        const raw = window.localStorage.getItem(getPurchaseSettingsStorageKey(userId));
        if (!raw) {
            return getDefaultPurchaseListSettings();
        }
        const parsed = JSON.parse(raw);
        return sanitizeSalesListSettings({
            ...getDefaultPurchaseListSettings(),
            ...parsed,
        });
    } catch (error) {
        return getDefaultPurchaseListSettings();
    }
}

export function savePurchaseListSettings(userId, settings) {
    window.localStorage.setItem(
        getPurchaseSettingsStorageKey(userId),
        JSON.stringify(sanitizeSalesListSettings(settings)),
    );
}

export { getDateRangeFromSalesSettings as getDateRangeFromPurchaseSettings, resolvePlantFilter };

export function resolveVendorFilter(settings, vendors) {
    const allIds = vendors.map((vendor) => String(vendor.value));
    const selectedIds = (settings.customerIds || [])
        .map((id) => String(id))
        .filter((id) => allIds.includes(id));

    if (!vendors.length || !selectedIds.length || selectedIds.length === allIds.length) {
        return '*';
    }
    return selectedIds.join(',');
}

export function getPurchaseSettingsSummary(settings, allowedPlants, vendors) {
    const [fromDate, toDate] = getDateRangeFromSalesSettings(settings);
    const plantCount = settings.plantIds?.length;
    const vendorCount = settings.customerIds?.length;
    const plantLabel = !plantCount || plantCount === allowedPlants.length
        ? `All plants (${allowedPlants.length})`
        : `${plantCount} plant(s)`;
    const vendorLabel = !vendorCount || vendorCount === vendors.length
        ? `All vendors (${vendors.length})`
        : `${vendorCount} vendor(s)`;

    let dateLabel = 'Current month';
    if (settings.dateMode === SALES_DATE_MODES.LAST_TWO_MONTHS) {
        dateLabel = 'Last two months';
    } else if (settings.dateMode === SALES_DATE_MODES.DATE_RANGE) {
        dateLabel = `${fromDate.format('DD-MM-YYYY')} to ${toDate.format('DD-MM-YYYY')}`;
    }

    return `${plantLabel} · ${vendorLabel} · ${dateLabel}`;
}
